export default __webpack_public_path__ + "static/media/body-yellow.56631e5a.png";